<template>
  <div class="row">
    <div class="col-lg-12">
      <h1 class="page-header">Subgrupos</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <list
            ref="vuetable"
            :show-empty="true"
            title="Listagem de Subgrupos"
            :api-url="apiUrl"
            report-title="Subgrupos"
            :fields="fields"
            :initial-page="pagina"
            :pageCollection="'subgrupos'"
            :appendParams="filtros"
          >
            <template slot="filters">
              <div class="collapse" id="filtros">
                <div class="col-sm-4">
                  <label class="custom-font" for="nome_filter">Nome</label>
                  <input
                    type="text"
                    v-model="nome"
                    class="form-control"
                    name="nome_filter"
                  />
                </div>

                <div class="col-sm-4">
                  <label class="custom-font" for="grupo_filter">Grupo</label>
                  <div class="custom-select">
                    <select
                      ref="grupo_codigo"
                      class="form-control select-selected"
                      name="grupo_codigo"
                      v-model="grupo_codigo"
                      @change="consultar"
                    >
                      <option value="">Todas</option>
                      <option
                        v-for="p in grupos"
                        :key="p.codigo"
                        :value="p.codigo"
                      >
                        {{ p.nome }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-xs-12">
                  <button
                    @click="consultar()"
                    class="btn btn-default margem-topo"
                    name="btnFiltrar"
                  >
                    <font-awesome-icon :icon="'filter'"></font-awesome-icon>
                    Filtrar
                  </button>
                  <button
                    @click="limpar()"
                    class="btn btn-default margem-topo"
                    name="btnLimpar"
                  >
                    <font-awesome-icon :icon="'eraser'"></font-awesome-icon>
                    Limpar Filtros
                  </button>
                </div>
              </div>
            </template>
            <template slot="actions">
              <router-link
                class="btn btn-default"
                :to="{ name: 'user_material_subgrupo_save' }"
                ><font-awesome-icon :icon="'plus'"></font-awesome-icon>
                Adicionar
              </router-link>
              <button
                class="btn btn-default"
                data-toggle="collapse"
                data-target="#filtros"
              >
                <font-awesome-icon :icon="'filter'"></font-awesome-icon> Filtros
              </button>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Excluir"
                  class="btn btn-danger"
                  @click="excluir(props.rowData)"
                >
                  <font-awesome-icon :icon="'trash'"></font-awesome-icon>
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  name: 'mp-subgrupos',
  inject: ["showConfirm"],
  data() {
    return {
      apiUrl: 'material/subgrupo',
      grupos: [],
      fields: [
        {
          name: 'nome',
          title: 'Nome',
          sortField: 'nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: 'grupo.nome',
          title: 'Grupo',
          sortField: 'grupo.nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ],
      carregando: false
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    this.loadGrupos()
  },
  methods: {
    async loadGrupos() {
      const response = await request.get('materiais/listar-grupos')
      this.grupos = response.data
    },
    excluir(data) {
      const me = this
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request
            .delete(this.apiUrl + '/' + data.codigo)
            .then(resp => {
              me.consultar()
              me.$toastr.s('Item removido com sucesso')
            })
            .catch(error => {
              me.$toastr.e(error.response.data)
            })
        }
      }
      this.showConfirm(
        'Deseja realmente deletar este item?',
        config
      )
    },
    consultar() {
      this.$nextTick(function () {
        this.$refs.vuetable.refresh()
      })
    },
    limpar() {
      this.nome = ''
      this.grupo_codigo = ''
      this.$refs.vuetable.refresh()
    },
    resetPageStore() {
      this.$store.commit('SET_FILTER_PAGE', {
        collection: 'subgrupos',
        value: 1
      })
    }
  },
  computed: {
    filtros() {
      const { nome, grupo_codigo } = this
      return {
        nome,
        grupo_codigo
      }
    },
    nome: {
      get() {
        const { subgrupos } = this.$store.state.vuetableState
        const { nome } = subgrupos.filtros
        return nome
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'nome',
          collection: 'subgrupos',
          value: value
        })
        this.resetPageStore()
      }
    },
    pagina: {
      get() {
        const { subgrupos } = this.$store.state.vuetableState
        const { pagina } = subgrupos
        return pagina
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'subgrupos',
          value: value
        })
      }
    },
    grupo_codigo: {
      get() {
        const { subgrupos } = this.$store.state.vuetableState
        const { grupo_codigo } = subgrupos.filtros
        return grupo_codigo
      },
      set(value) {
        this.$store.commit('SET_FILTER_FIELD', {
          field: 'grupo_codigo',
          collection: 'subgrupos',
          value: value
        })
        this.resetPageStore()
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/materiais-padronizados/subgrupo/index.vue